// extracted by mini-css-extract-plugin
export default {"label":"item_label__QxwRt","selected":"item_selected__nY813"};